export default [
    
  {
      path: 'content',
      component: resolve => require(['@/views/page'], resolve),
      name: 'content'
  },
  {
    path: 'contentForm',
    component: resolve => require(['@/views/contentForm'],resolve),
    name: 'contentForm'
  }
]


// WEBPACK FOOTER //
// ./src/router/news.js